import { useEffect, useState } from "react";
import { Button, Card, Col, Dropdown, Form, InputGroup, Nav, NavItem, Row, Tab } from "react-bootstrap"
import { useLocation, useNavigate } from "react-router-dom";
import { customFormatDate, formatDate, formatDateTime, getTimeAgo } from "../../../../../Components/DateFn";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import OpenActivitiesView from "../OpenActivitiesView";
import ClosedActivitiesView from "../ClosedActivitiesView";
import Select from "react-select";
import { Helpers } from "../../../../../Helpers";
import { Utils } from "../../../../../Utils";
import PermissionDeniedModal from "../../../../../Components/PermissionDeniedModal";
import ConfirmationModal from "../../../../../Components/ModalPopup/ConfirmationModal";
import EmailComposer from "../../../../../Components/EmailComposer";
import { getSubFormKanbanListStart, removeSubFormByIdStart, resetDeleteStatus, resetStateModule, updateSubFormByIdStart } from "../../../../../Store/Slices/subFormSlice";
import Loader from "../../../../../Components/Loader";
import { Check, Clock3, Pencil, X } from "lucide-react";
import { getDealLogStart, getDealActivitiesStart } from "../../../../../Store/Slices/dealSlice";

const LeadDetails = ({ card, id, subFormData, basicPermissionData }) => {
    let defaultImg = "https://campussafetyconference.com/wp-content/uploads/2020/08/iStock-476085198.jpg";

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    let users = useSelector((state) => state?.user);
    const dealActivities = useSelector((state) => state?.deal)?.dealActivitiesData;
    const formsubmodules = useSelector((state) => state?.subForm);
    // const { card, id, subFormData, basicPermissionData } = location.state || {};
    // let defaultStages = subFormData?.modules?.stageProbability;
    const [cardData, setCardData] = useState(card || {});
    const [updateCardStatus, setUpdateCardStatus] = useState(false);
    const [key, setKey] = useState('Qualification');
    let [stageName, setStageName] = useState('');
    const [openDropdown, setOpenDropdown] = useState(null);

    const [hoverDealInfo, setHoverDealInfo] = useState(false);
    const [isEditDealInfo, setIsEditDealInfo] = useState(false);

    let [sendEmail, setSendEmail] = useState(false);
    let [permissionDenied, setPermissionDenied] = useState(false);
    let [removeModalData, setRemoveModalData] = useState(null);
    let [optionsList, setOptionsList] = useState([]);
    let [accountsList, setAccountsList] = useState([]);
    let [contactsList, setContactsList] = useState([]);

    let stageHistoryTableHeaders = ['Stage', 'Amount', 'Probability (%)', 'Expected Revenue', 'Closing Date', 'Modified Time'];

    useEffect(() => {
        if (formsubmodules?.kanbanData?.formsubmodules?.length > 0) {
            let updatedCard = formsubmodules?.kanbanData?.formsubmodules?.find(item => item._id === cardData?._id);
            const mergedObject = updatedCard?.data?.reduce((acc, curr) => {
                return { ...acc, ...curr.section_data };
            }, {});
            if (mergedObject) {
                mergedObject['createdAt'] = updatedCard?.createdAt;
                mergedObject['updatedAt'] = updatedCard?.updatedAt;
                mergedObject['createdBy'] = updatedCard?.userId;
                mergedObject['updatedBy'] = updatedCard?.updatedBy;
                mergedObject['userId'] = updatedCard?.userId;
                mergedObject['_id'] = updatedCard?._id;
                mergedObject['status'] = updatedCard?.status;
                setCardData(mergedObject);
            }
        }
    }, [formsubmodules?.kanbanData?.formsubmodules]);

    // useEffect(() => {
    //     if (subFormData?.lookupData["Account Name"]?.length > 0) {
    //         let list = subFormData?.lookupData["Account Name"];
    //         let data = [];
    //         for (let x of list) {
    //             if (x?.data?.length > 0) {
    //                 for (let y of x?.data) {
    //                     let title = "Account Name";
    //                     let possibleKeys = [Helpers.replaceData(title), Helpers.replaceData(title + "_")];
    //                     for (let key of possibleKeys) {
    //                         let val = y?.section_data?.[key] || null;
    //                         if (y?.section_data?.hasOwnProperty(key) && !Array.isArray(val) && val) {
    //                             data.push({ _id: x?._id, name: (typeof val === "string" ? val : (val?.name || "")) });
    //                             break;
    //                         }
    //                     }
    //                 }
    //             }
    //         }
    //         setAccountsList(data);
    //     }

    //     if (subFormData?.lookupData["Contact Name"]?.length > 0) {
    //         let list = subFormData?.lookupData["Contact Name"];
    //         let data = [];
    //         for (let x of list) {
    //             if (x?.data?.length > 0) {
    //                 for (let y of x?.data) {
    //                     let title = "Contact Owner";
    //                     let possibleKeys = [Helpers.replaceData(title), Helpers.replaceData(title + "_")];
    //                     for (let key of possibleKeys) {
    //                         let val = y?.section_data?.[key] || null;
    //                         if (y?.section_data?.hasOwnProperty(key) && !Array.isArray(val) && val) {
    //                             data.push({ _id: x?._id, name: (typeof val === "string" ? val : (val?.name || "")) });
    //                             break;
    //                         }
    //                     }
    //                 }
    //             }
    //         }
    //         setContactsList(data);
    //     }
    // }, [subFormData?.lookupData])

    useEffect(() => {
        if (users?.allUserData?.length > 0) {
            setOptionsList(users?.allUserData?.map(x => (x?._id?.length > 0 ? {
                _id: x?._id,
                name: `${x?.firstName || ''} ${x?.lastName || ''}`,
                profilePicture: x?.profilePicture,
                email: x?.email
            } : x)));
        } else {
            setOptionsList([])
        }
    }, [users?.allUserData])

    // useEffect(() => {
    //     if (cardData?.Stage) {
    //         setStageName(defaultStages.find(stage => stage.id === Number(cardData?.Stage))?.stageName || '');
    //         setKey(defaultStages.find(stage => stage.id === Number(cardData?.Stage))?.stageName || 'Qualification');
    //     }
    // }, [cardData?.Stage]);

    useEffect(() => {
        if (cardData?._id) {
            // dispatch(getDealLogStart(cardData?._id));
            dispatch(getDealActivitiesStart(cardData?._id));
            dispatch(getSubFormKanbanListStart({ id }));
        }
    }, []);

    useEffect(() => {
        if (formsubmodules?.updateStatus && id) {
            setUpdateCardStatus(true);
            if (id) dispatch(getSubFormKanbanListStart({ id }));
            // if (cardData?._id) dispatch(getDealLogStart(cardData?._id));
        }
    }, [formsubmodules?.updateStatus]);

    useEffect(() => {
        if (updateCardStatus && formsubmodules?.kanbanData?.formsubmodules?.length > 0) {
            let updatedCard = formsubmodules?.kanbanData?.formsubmodules?.find(item => item._id === cardData?._id);
            const mergedObject = updatedCard?.data?.reduce((acc, curr) => {
                return { ...acc, ...curr.section_data };
            }, {});
            if (mergedObject) {
                mergedObject['createdAt'] = updatedCard?.createdAt;
                mergedObject['updatedAt'] = updatedCard?.updatedAt;
                mergedObject['createdBy'] = updatedCard?.userId;
                mergedObject['updatedBy'] = updatedCard?.updatedBy;
                mergedObject['userId'] = updatedCard?.userId;
                mergedObject['_id'] = updatedCard?._id;
                mergedObject['status'] = updatedCard?.status;
                setCardData(mergedObject);
            }
        }
    }, [formsubmodules?.kanbanData?.formsubmodules]);

    useEffect(() => {
        if (formsubmodules?.deleteStatus === true) {
            dispatch(resetDeleteStatus());
            navigate(-1);
        }
    }, [formsubmodules?.deleteStatus])

    const getCurrency = (amt) => {
        return parseFloat(amt.replace(/,/g, '')).toFixed(2)
    }

    // const handleUpdateStage = (stage) => {
    //     // let stage_id = defaultStages.find(stg => stg?.stageName === stage)?.id
    //     // if (stage_id && String(stage_id) !== cardData?.Stage && cardData?._id && id && subFormData?.kanbanData?.formsubmodules?.length > 0) {
    //     //     let isSubFormData = subFormData?.kanbanData?.formsubmodules?.find((item) => item._id === cardData?._id)?.data
    //     //     let updateKeys = {
    //     //         formsubmodules: "formsubmodules",
    //     //         message: "message",
    //     //         exit: "exit",
    //     //         isLoading: "isLoading",
    //     //         status: "status",
    //     //         reload: "reload",
    //     //         error: "error"
    //     //     }

    //     //     let sections = isSubFormData?.map(section =>
    //     //         section.section_name === "Deal Information"
    //     //             ? {
    //     //                 ...section,
    //     //                 section_data: {
    //     //                     ...section.section_data,
    //     //                     Stage: String(defaultStages?.find(x => x?.stageName === stage)?.id),
    //     //                     Probability_: defaultStages?.find(x => x?.stageName === stage)?.probability,
    //     //                     Expected_Revenue: getCurrency(cardData?.Amount) * (defaultStages?.find(x => x?.stageName === stage)?.probability / 100)
    //     //                 }
    //     //             }
    //     //             : section
    //     //     );

    //     //     const dealInfo = sections?.find(s => s?.section_name === "Deal Information");
    //     //     const dealOwnerId = dealInfo?.section_data?.Deal_Owner?._id;

    //     //     const mergedObject = sections.reduce((acc, curr) => {
    //     //         return { ...acc, ...curr.section_data };
    //     //     }, {});

    //     //     let payload = {
    //     //         audit_log: { msg: '' },
    //     //         data: sections,
    //     //         moduleId: id,
    //     //         userId: dealOwnerId,
    //     //         stage_history: mergedObject
    //     //     }

    //     //     dispatch(updateSubFormByIdStart({
    //     //         subModuleId: cardData?._id,
    //     //         payload: payload,
    //     //         updateKeys
    //     //     }));
    //     // }
    // }

    const handleUpdateLeadData = () => {
        if (cardData?._id && id && subFormData?.formsubmodules?.length > 0) {
            let isSubFormData = subFormData?.formsubmodules?.find((item) => item._id === cardData?._id)?.data
            let updateKeys = {
                formsubmodules: "formsubmodules",
                message: "message",
                exit: "exit",
                isLoading: "isLoading",
                status: "status",
                reload: "reload",
                error: "error"
            }

            const updatedSections = isSubFormData.map((section) => {
                const updatedSectionData = { ...section.section_data };

                Object.keys(section.section_data).forEach((key) => {
                    if (cardData.hasOwnProperty(key)) {
                        updatedSectionData[key] = cardData[key];
                    }
                });

                return {
                    ...section,
                    section_data: updatedSectionData,
                };
            });

            const dealInfo = updatedSections?.find(s => s?.section_name === "Deal Information");
            const dealOwnerId = dealInfo?.section_data?.Deal_Owner?._id;

            let payload = {
                audit_log: { msg: '' },
                data: updatedSections,
                moduleId: id,
                userId: dealOwnerId,
            }

            dispatch(updateSubFormByIdStart({
                subModuleId: cardData?._id,
                payload: payload,
                updateKeys
            }));
        }
    }

    const removeData = (subModuleId) => {
        dispatch(removeSubFormByIdStart(subModuleId));
    }

    const handleChange = (e) => {
        try {
            const { name, value } = e.target;
            //     if (name === 'Stage') {
            //         setStageName(value);
            //         setCardData((prev) => ({
            //             ...prev,
            //             Stage: String(defaultStages?.find(x => x?.stageName === value)?.id),
            //             Probability_: defaultStages?.find(x => x?.stageName === value)?.probability,
            //             Expected_Revenue: getCurrency(cardData?.Amount) * (defaultStages?.find(x => x?.stageName === value)?.probability / 100)
            //         }));
            //     } else if (name === 'Amount') {
            //         setCardData((prev) => ({
            //             ...prev,
            //             [name]: value,
            //             Expected_Revenue: getCurrency(value) * (defaultStages?.find(x => x?.stageName === stageName)?.probability / 100)
            //         }));
            //     } else {
            setCardData((prev) => ({
                ...prev,
                [name]: value
            }));
            //     }
        } catch (err) {
            throw err;
        }
    }

    const handleChangeLeadOwner = (e) => {
        try {
            setCardData((prev) => ({
                ...prev,
                Lead_Owner: { _id: e?._id, name: e?.name }
            }));
        } catch (err) {
            throw err;
        }
    }

    const handleChangeLookup = (e, field) => {
        try {
            setCardData((prev) => ({
                ...prev,
                [field]: e
            }));
        } catch (err) {
            throw err;
        }
    }

    const handleSave = () => {
        setIsEditDealInfo(false);
        setHoverDealInfo(false);
        handleUpdateLeadData();
    }

    let CustomOption = ({ data, innerRef, innerProps }) => (
        data.email ?
            <>
                <div ref={innerRef} {...innerProps} className="d-flex align-items-center p-2">
                    <img
                        src={data.profilePicture}
                        alt={data.name}
                        className="rounded-circle me-2"
                        style={{ width: '30px', height: '30px' }}
                    />
                    <div>
                        <div>{data.name}</div>
                        <small className="text-muted">{data.email}</small>
                    </div>
                </div>
            </> :
            <>
                <div ref={innerRef} {...innerProps} className="d-flex align-items-center p-2">
                    <span>{data.name}</span>
                </div>
            </>
    );

    let customStyles = {
        multiValue: (provided) => ({
            ...provided,
            borderRadius: "5px",
        }),
        menu: (provided) => ({
            ...provided,
            zIndex: 9999
        })
    };
    console.log('cardData', cardData);
    return (
        <>
            <Loader isVisible={formsubmodules?.isLoading} />
            <div className="container-fluid">
                <Card className="py-1">
                    <Row>
                        <div className="col-6 d-inline-flex align-items-center">
                            <div className="me-3">
                                <i className="fa fa-arrow-left me-2 cursor-pointer" onClick={() => navigate(-1)}></i>
                            </div>
                            <div>
                                <img src={cardData?.Profile_Picture ?? defaultImg}
                                    alt='lead-user-img' width={40} height={40}
                                    style={{ opacity: cardData?.Profile_Picture ? 1 : 0.3 }}
                                    className="rounded-circle me-2"
                                />
                                <span className="fw-semibold">{cardData?.First_Name} {cardData?.Last_Name}</span> - {cardData?.Company_Name}
                            </div>
                        </div>
                        <div className="col-6 d-flex justify-content-end align-items-center">
                            <Button variant='primary'
                                className="me-2"
                                onClick={() => {
                                    setSendEmail(true);
                                }}
                            >Send Mail</Button>
                            <Dropdown>
                                <Dropdown.Toggle variant="light border pe-2 with-arrow">
                                    <span className='pe-4'>Actions</span>
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="shadow-sm rounded-2">
                                    {/* <Dropdown.Item
                                        onClick={() => {
                                            dispatch(resetStateModule());
                                            navigate(
                                                Utils.getNavigationUrl(`form-module/sub-form/update/${id}/${cardData?._id}`)
                                            );
                                        }}
                                    >Convert</Dropdown.Item> */}
                                    <Dropdown.Item
                                        onClick={() => {
                                            dispatch(resetStateModule());
                                            navigate(
                                                Utils.getNavigationUrl(`form-module/sub-form/update/${id}/${cardData?._id}`)
                                            );
                                        }}
                                    >Edit</Dropdown.Item>
                                    <Dropdown.Item
                                        onClick={() =>
                                            !basicPermissionData?.some(
                                                (x) => x?.id === id && x.activities.delete === true
                                            )
                                                ? setPermissionDenied(true)
                                                : cardData?._id
                                                    ? setRemoveModalData({
                                                        subModuleId: cardData?._id,
                                                        payload: {
                                                            _id: cardData?._id,
                                                            moduleId: id
                                                        }
                                                    })
                                                    : console.error('rowId is undefined')
                                        }
                                    >Delete</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </Row>
                </Card>

                <Tab.Container id="pill-tab" defaultActiveKey={key}>
                    <Tab.Content>
                        <Tab.Pane eventKey="Qualification">
                            <Card body className="mt-2 p-0">
                                <Form.Group as={Row}
                                    className="mb-1 align-items-center position-relative"
                                    controlId="leadOwner"
                                >
                                    <Form.Label column sm="2" className="label-color">
                                        Lead Owner
                                    </Form.Label>
                                    <Col sm="4" className="position-relative">
                                        <div className="d-flex align-items-center position-relative">
                                            <Form.Control plaintext={true} readOnly={true} value={cardData?.Lead_Owner?.name} />
                                        </div>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-1" controlId="leadEmail">
                                    <Form.Label column sm="2" className="label-color">
                                        Email
                                    </Form.Label>
                                    <Col sm="10">
                                        <Form.Control plaintext={true} readOnly={true} value={cardData?.Email} />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-1" controlId="leadPhone">
                                    <Form.Label column sm="2" className="label-color">
                                        Phone
                                    </Form.Label>
                                    <Col sm="10">
                                        <Form.Control plaintext={true} readOnly={true} value={cardData?.Phone} />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-1" controlId="leadMobile">
                                    <Form.Label column sm="2" className="label-color">
                                        Mobile
                                    </Form.Label>
                                    <Col sm="10">
                                        <Form.Control plaintext={true} readOnly={true} value={cardData?.Mobile} />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-1" controlId="leadStatus">
                                    <Form.Label column sm="2" className="label-color">
                                        Lead Status
                                    </Form.Label>
                                    <Col sm="10">
                                        <Form.Control plaintext={true} readOnly={true} value={cardData?.Lead_Status} />
                                    </Col>
                                </Form.Group>
                            </Card>
                            <Card body className="mt-2 p-0">
                                <Card.Title as={'h6'} className="fw-medium mb-3"
                                    onMouseEnter={() => setHoverDealInfo(true)}
                                    onMouseLeave={() => setHoverDealInfo(false)}
                                >Lead Information
                                    {hoverDealInfo && !isEditDealInfo && (
                                        <Pencil
                                            className="icon-btn icon-edit-deal"
                                            size={18}
                                            onClick={() => { setIsEditDealInfo(true); }}
                                        />
                                    )}
                                    {isEditDealInfo && (
                                        <div className="d-flex align-items-center icon-group">
                                            <Check className="icon-btn icon-save-deal" size={18} style={{ marginRight: '30px' }} onClick={() => handleSave()} />
                                            <X className="icon-btn icon-cancel-deal" size={18} onClick={() => { setCardData(card); setHoverDealInfo(false); setIsEditDealInfo(false); }} />
                                        </div>
                                    )}
                                </Card.Title>
                                <Row>
                                    <div className="col-6">
                                        <Form.Group as={Row}
                                            className="mb-1 align-items-center position-relative"
                                            controlId="leadInfoOwner"
                                        >
                                            <Form.Label column sm="4" className="label-color">
                                                Lead Owner
                                            </Form.Label>
                                            <Col sm="8" className="position-relative">
                                                <div className="d-flex align-items-center position-relative">
                                                    {!isEditDealInfo ?
                                                        <Form.Control plaintext={!isEditDealInfo} readOnly={!isEditDealInfo} value={cardData?.Lead_Owner?.name} className="no-focus-border" />
                                                        : <div className={`form-control multi-select border-0 p-0`}>
                                                            <Select
                                                                options={optionsList}
                                                                isMulti={false}
                                                                value={cardData?.Lead_Owner}
                                                                name="Lead_Owner"
                                                                onChange={(e) => handleChangeLeadOwner(e)}
                                                                placeholder="Select Options"
                                                                getOptionLabel={(option) => option.name}
                                                                getOptionValue={(option) => (option?._id?.length > 0 ? option?._id : option.name)}
                                                                components={{ Option: CustomOption }}
                                                                styles={customStyles}
                                                                className="multiSelectContainer"
                                                                classNamePrefix="select"
                                                                closeMenuOnSelect={true}
                                                                menuPosition={"fixed"}
                                                                // menuIsOpen
                                                                menuPortalTarget={document.getElementById('root')}
                                                                isClearable={true}
                                                                classNames={{
                                                                    menuPortal: (state) => 'react-select-portal',
                                                                }}
                                                            />
                                                        </div>
                                                    }
                                                </div>
                                            </Col>
                                        </Form.Group>
                                        <Form.Group as={Row}
                                            className="mb-1 align-items-center position-relative"
                                            controlId="leadInfoPhone"
                                        >
                                            <Form.Label column sm="4" className="label-color">
                                                Phone
                                            </Form.Label>
                                            <Col sm="8">
                                                <div className="d-flex align-items-center position-relative">
                                                    <Form.Control
                                                        plaintext={!isEditDealInfo}
                                                        readOnly={!isEditDealInfo}
                                                        value={cardData?.Phone}
                                                        name="Phone"
                                                        onChange={(e) => handleChange(e)}
                                                        className={!!isEditDealInfo ? "no-focus-border" : ""}
                                                    />
                                                </div>
                                            </Col>
                                        </Form.Group>

                                        <Form.Group as={Row}
                                            className="mb-1 align-items-center position-relative"
                                            controlId="leadInfoMobile"
                                        >
                                            <Form.Label column sm="4" className="label-color">
                                                Mobile
                                            </Form.Label>
                                            <Col sm="8">
                                                <div className="d-flex align-items-center position-relative">
                                                    <Form.Control
                                                        plaintext={!isEditDealInfo}
                                                        readOnly={!isEditDealInfo}
                                                        value={cardData?.Mobile}
                                                        name="Mobile"
                                                        onChange={(e) => handleChange(e)}
                                                        className={!!isEditDealInfo ? "no-focus-border" : ""}
                                                    />
                                                </div>
                                            </Col>
                                        </Form.Group>
                                        <Form.Group as={Row} className="mb-1" controlId="leadInfoLeadSource">
                                            <Form.Label column sm="4" className="label-color">
                                                Lead Source
                                            </Form.Label>
                                            <Col sm="8">
                                                <Form.Control
                                                    plaintext={true}
                                                    readOnly={true}
                                                    value={cardData?.Lead_Source}
                                                    className="no-focus-border"
                                                />
                                            </Col>
                                        </Form.Group>
                                        <Form.Group as={Row} className="mb-1" controlId="leadInfoIndustry">
                                            <Form.Label column sm="4" className="label-color">
                                                Industry
                                            </Form.Label>
                                            <Col sm="8">
                                                <Form.Control
                                                    plaintext={true}
                                                    readOnly={true}
                                                    value={cardData?.Industry}
                                                    className="no-focus-border"
                                                />
                                            </Col>
                                        </Form.Group>
                                        <Form.Group as={Row}
                                            className="mb-1 align-items-center position-relative"
                                            controlId="leadInfoEmaillOptOut"
                                        >
                                            <Form.Label column sm="4" className="label-color">
                                                Email Opt Out
                                            </Form.Label>
                                            <Col sm="8">
                                                <div className="d-flex align-items-center position-relative">
                                                    <Form.Control plaintext={true} readOnly={true} value={cardData?.Email_Opt_Out} className="no-focus-border" />
                                                </div>
                                            </Col>
                                        </Form.Group>
                                        <Row className="mb-1">
                                            <Col sm="4" className="label-color form-label col-form-label">
                                                Modified By
                                            </Col>
                                            <Col sm="8">
                                                {cardData?.updatedBy?.firstName && <div style={{ fontWeight: 500 }}>{cardData?.updatedBy?.firstName + ' ' + cardData?.updatedBy?.lastName || ''}</div>}
                                                <div>{customFormatDate(cardData?.updatedAt)}</div>
                                            </Col>
                                        </Row>
                                    </div>
                                    <div className="col-6">
                                        <Form.Group as={Row} className="mb-1" controlId="leadInfoCompany">
                                            <Form.Label column sm="4" className="label-color">
                                                Company
                                            </Form.Label>
                                            <Col sm="8">
                                                <div className="d-flex align-items-center position-relative">
                                                    <Form.Control
                                                        plaintext={!isEditDealInfo}
                                                        readOnly={!isEditDealInfo}
                                                        value={cardData?.Company_Name}
                                                        name="Company"
                                                        onChange={(e) => handleChange(e)}
                                                        className={!!isEditDealInfo ? "no-focus-border" : ""}
                                                    />
                                                </div>
                                            </Col>
                                        </Form.Group>
                                        <Form.Group as={Row} className="mb-1" controlId="leadInfoLeadName">
                                            <Form.Label column sm="4" className="label-color">
                                                Lead Name
                                            </Form.Label>
                                            <Col sm="8">
                                                <Form.Control
                                                    plaintext={true}
                                                    readOnly={true}
                                                    value={cardData?.First_Name + ' ' + cardData?.Last_Name}
                                                    className="no-focus-border"
                                                />
                                            </Col>
                                        </Form.Group>
                                        <Form.Group as={Row} className="mb-1" controlId="leadInfoEmail">
                                            <Form.Label column sm="4" className="label-color">
                                                Email
                                            </Form.Label>
                                            <Col sm="8">
                                                <Form.Control
                                                    plaintext={!isEditDealInfo}
                                                    readOnly={!isEditDealInfo}
                                                    value={cardData?.Email}
                                                    name="Email"
                                                    onChange={(e) => handleChange(e)}
                                                    className={!!isEditDealInfo ? "no-focus-border" : ""} />
                                            </Col>
                                        </Form.Group>
                                        <Form.Group as={Row} className="mb-1" controlId="leadInfoWebsite">
                                            <Form.Label column sm="4" className="label-color">
                                                Website
                                            </Form.Label>
                                            <Col sm="8">
                                                <Form.Control
                                                    plaintext={!isEditDealInfo}
                                                    readOnly={!isEditDealInfo}
                                                    value={cardData?.Website}
                                                    name="Website"
                                                    onChange={(e) => handleChange(e)}
                                                    className={!!isEditDealInfo ? "no-focus-border" : ""}
                                                />
                                            </Col>
                                        </Form.Group>
                                        <Form.Group as={Row} className="mb-1" controlId="leadInfoLeadStatus">
                                            <Form.Label column sm="4" className="label-color">
                                                Lead Status
                                            </Form.Label>
                                            <Col sm="8">
                                                <Form.Control
                                                    plaintext={true}
                                                    readOnly={true}
                                                    value={cardData?.Lead_Status}
                                                    className="no-focus-border"
                                                />
                                            </Col>
                                        </Form.Group>
                                        <Form.Group as={Row} className="mb-1" controlId="leadInfoSource">
                                            <Form.Label column sm="4" className="label-color">
                                                Source
                                            </Form.Label>
                                            <Col sm="8">
                                                <Form.Control plaintext={true} readOnly={true} value={cardData?.Source}
                                                    className="no-focus-border"
                                                />
                                            </Col>
                                        </Form.Group>
                                        <Row className="mb-1">
                                            <Col sm="4" className="label-color form-label col-form-label">
                                                Created By
                                            </Col>
                                            <Col sm="8">
                                                <div style={{ fontWeight: 500 }}>{cardData?.createdBy?.firstName + ' ' + cardData?.createdBy?.lastName || ''}</div>
                                                <div>{customFormatDate(cardData?.createdAt)}</div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Row>

                                <Card.Title as={'h6'} className="fw-medium">Address Information</Card.Title>
                                <Row>
                                    <div className="col-6">
                                        <Form.Group as={Row} className="mb-1" controlId="leadInfoStreet">
                                            <Form.Label column sm="4" className="label-color">
                                                Street
                                            </Form.Label>
                                            <Col sm="8">
                                                <Form.Control as="textarea"
                                                    plaintext={!isEditDealInfo}
                                                    readOnly={!isEditDealInfo}
                                                    value={cardData?.Street}
                                                    name="Street"
                                                    onChange={(e) => handleChange(e)}
                                                    className={!!isEditDealInfo ? "no-focus-border" : ""}
                                                />
                                            </Col>
                                        </Form.Group>
                                        <Form.Group as={Row} className="mb-1" controlId="leadInfoState">
                                            <Form.Label column sm="4" className="label-color">
                                                State
                                            </Form.Label>
                                            <Col sm="8">
                                                <Form.Control
                                                    plaintext={!isEditDealInfo}
                                                    readOnly={!isEditDealInfo}
                                                    value={cardData?.State}
                                                    name="State"
                                                    onChange={(e) => handleChange(e)}
                                                    className={!!isEditDealInfo ? "no-focus-border" : ""}
                                                />
                                            </Col>
                                        </Form.Group>
                                        <Form.Group as={Row} className="mb-1" controlId="leadInfoCountry">
                                            <Form.Label column sm="4" className="label-color">
                                                Country
                                            </Form.Label>
                                            <Col sm="8">
                                                <Form.Control
                                                    plaintext={!isEditDealInfo}
                                                    readOnly={!isEditDealInfo}
                                                    value={cardData?.Country}
                                                    name="Country"
                                                    onChange={(e) => handleChange(e)}
                                                    className={!!isEditDealInfo ? "no-focus-border" : ""}
                                                />
                                            </Col>
                                        </Form.Group>
                                    </div>
                                    <div className="col-6">
                                        <Form.Group as={Row} className="mb-1" controlId="leadInfoCity">
                                            <Form.Label column sm="4" className="label-color">
                                                City
                                            </Form.Label>
                                            <Col sm="8">
                                                <Form.Control
                                                    plaintext={!isEditDealInfo}
                                                    readOnly={!isEditDealInfo}
                                                    value={cardData?.City}
                                                    name="City"
                                                    onChange={(e) => handleChange(e)}
                                                    className={!!isEditDealInfo ? "no-focus-border" : ""}
                                                />
                                            </Col>
                                        </Form.Group>
                                        <Form.Group as={Row} className="mb-1" controlId="leadInfoZipcode">
                                            <Form.Label column sm="4" className="label-color">
                                                Zipcode
                                            </Form.Label>
                                            <Col sm="8">
                                                <Form.Control
                                                    plaintext={!isEditDealInfo}
                                                    readOnly={!isEditDealInfo}
                                                    value={cardData?.Zip_Code}
                                                    name="Zip_Code"
                                                    onChange={(e) => handleChange(e)}
                                                    className={!!isEditDealInfo ? "no-focus-border" : ""}
                                                />
                                            </Col>
                                        </Form.Group>
                                    </div>
                                </Row>

                                <Card.Title as={'h6'} className="fw-medium">Product Information</Card.Title>
                                <Row>
                                    <div className="col-6">
                                        <Form.Group as={Row} className="mb-1" controlId="leadInfoProducts">
                                            <Form.Label column sm="4" className="label-color">
                                                Products
                                            </Form.Label>
                                            {cardData?.Multi_Select_Lookup && cardData?.Multi_Select_Lookup.length > 0 &&
                                                <Col sm="8">
                                                    <Form.Control plaintext readOnly
                                                        value={cardData?.Multi_Select_Lookup?.map((data) => data.name).join(', ')}
                                                        className="no-focus-border"
                                                    />
                                                </Col>
                                            }
                                        </Form.Group>
                                    </div>
                                </Row>

                                <Card.Title as={'h6'} className="fw-medium">Description</Card.Title>
                                <Row>
                                    <div className="col-6">
                                        <Form.Group as={Row} className="mb-1" controlId="leadInfoDescription">
                                            <Form.Label column sm="4" className="label-color">
                                                Description
                                            </Form.Label>
                                            <Col sm="8">
                                                {!isEditDealInfo ?
                                                    <Form.Control as="textarea" rows={3} plaintext={!isEditDealInfo} readOnly={!isEditDealInfo} value={cardData?.Multi_Line} className="no-focus-border" />
                                                    : <Form.Control
                                                        as="textarea" rows={3}
                                                        value={cardData?.Multi_Line}
                                                        name="Multi_Line"
                                                        onChange={(e) => handleChange(e)}
                                                    />
                                                }
                                            </Col>
                                        </Form.Group>
                                    </div>
                                </Row>
                            </Card>
                            {/* open activities */}
                            <Card body className="mt-2 p-0">
                                <Card.Title as={'h6'} className="fw-medium">Open Activities</Card.Title>
                                <Row>
                                    <div className="col-md-12">
                                        <OpenActivitiesView activities={dealActivities} />
                                    </div>
                                </Row>
                            </Card>
                            {/* closed activities */}
                            <Card body className="mt-2 mb-3 p-0">
                                <Card.Title as={'h6'} className="fw-medium">Closed Activities</Card.Title>
                                <Row>
                                    <div className="col-md-12">
                                        <ClosedActivitiesView activities={dealActivities} />
                                    </div>
                                </Row>
                            </Card>
                        </Tab.Pane>
                    </Tab.Content>
                </Tab.Container>
            </div >
            {sendEmail &&
                <EmailComposer
                    sendEmail={sendEmail}
                    setSendEmail={setSendEmail}
                    id={id}
                    selectedRowData={cardData}
                    moduleName='Deals'
                />
            }
            {permissionDenied && <PermissionDeniedModal />}
            {removeModalData && (<ConfirmationModal data={removeModalData} show={true} handleClose={() => setRemoveModalData(null)} handleSuccess={(subModuleId) => {
                removeData({ subModuleId: removeModalData.subModuleId, payload: { moduleId: removeModalData.payload.moduleId } });
                setRemoveModalData(null);
            }}
            />)}
        </>
    )
}
export default LeadDetails;